import { render, staticRenderFns } from "./ProductAndServices.vue?vue&type=template&id=2273b9b5&scoped=true&"
import script from "./ProductAndServices.vue?vue&type=script&lang=ts&"
export * from "./ProductAndServices.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAndServices.vue?vue&type=style&index=0&id=2273b9b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273b9b5",
  null
  
)

export default component.exports